// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Marshall Islands */
const MH = /^(?:(?:(?:23|54)5|329|45[35-8])\d{4})$/;

export default MH;
